import { t } from '@/i18n';
import { z } from 'zod';

const errorMessages = {
  required: t('pages.login.schemas.two_factor.required'),
};

export const twoFactorFormSchema = z.object({
  code: z.string().min(1, errorMessages.required),
});
